/* eslint-disable prettier/prettier */
import { KeyValuePair } from '../../ui/KeyValuePair';
import { CollapsibleSection } from '../CollapsibleSection';
import { formatDate } from '../../../utils/formatDate';
import { formatSize } from '../../../utils/formatSize';
import { emojiIconMap } from '../../../utils/emojiIconMap';

export const FileInfoSection = ({
  file,
  refreshTreatyData,
}: {
  file: any;
  refreshTreatyData?: () => void;
}) => {
  const baseFields = [
    { key: 'fileName', label: 'File Name' },
    {
      key: 'size',
      label: 'Size',
      formatter: (val: any) => formatSize(val),
    },
    {
      key: 'uploadedAt',
      label: 'Uploaded At',
      formatter: (val: any) => formatDate(val),
    },
  ];

  const conditionalFields = [];

  if (file?.editedName && file.editedName.trim() !== '') {
    conditionalFields.push({ key: 'editedName', label: 'Edited Name' });
  }

  if (file?.description && file.description.trim() !== '') {
    conditionalFields.push({ key: 'description', label: 'Description' });
  }

  const fields = [...baseFields, ...conditionalFields];

  return (
    <CollapsibleSection title="File Info" icon={emojiIconMap['File Info']}>
      {fields.map(({ key, label, formatter }) => (
        <KeyValuePair
          key={key}
          label={label}
          value={formatter ? formatter(file[key]) : file[key]}
          editable={false}
          refreshTreatyData={refreshTreatyData}
        />
      ))}
    </CollapsibleSection>
  );
};
